import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  Grid,
  Input,
  TextField,
  Typography,
} from "@mui/material";

import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { ChangeEvent, useEffect, useState } from "react";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import CancelIcon from "@mui/icons-material/Cancel";
import MainContainer from "../../layout/MainContainer";
import { Link, useNavigate } from "react-router-dom";
import { useFormik } from "formik";

import * as Yup from "yup";
import useAuth from "../../hooks/useAuth";
import {
  STORAGE_KEYS,
  errorToast,
  getFromStorage,
  removeFromStorage,
  setToStorage,
  successToast,
} from "../../helpers";
import { UploadMedia } from "../../utils/uploadMedia";
import { CommonBody } from "../../types/General";
import { generateEncryptedKeyBody } from "../../utils/crypto";
import { usePutUpdateProfileMutation } from "../../services/profile";
import { UploadResponse } from "../../types/User";
import { useSelector } from "react-redux";
import { getToken, setCredentials } from "../../reducers/authSlice";
import { useAppDispatch } from "../../hooks/store";
const Profile = () => {
  const token: any = useSelector(getToken);
  const dispatch = useAppDispatch();
  const user = useAuth();
  const navigate = useNavigate();
  const [updateprofilre] = usePutUpdateProfileMutation();
  const [dialCode, setPhoneCode] = useState("+1");
  const [profile_picture, setProfilePicture] = useState<any>(null);
  const [imageId, setImageId] = useState(null);

  const handleImageUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const files = event.target.files;
    const file = files?.length ? files[0] : null;

    try {
      if (!file) {
        formik.setFieldValue("profile_picture", "");
        setProfilePicture("");
        setImageId(null);
        return;
      }

      const res = await UploadMedia(file);
      if (res?.statusCode === 200) {
        formik.setFieldValue("profile_picture", res?.data?.image);
        setProfilePicture(res?.data?.image);
      } else {
        errorToast(res?.message);
      }
    } catch (error) {
      console.error("Error uploading image:", error);
      errorToast("Error uploading image. Please try again.");
    }
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: user?.email || "",
      first_name: user?.firstName || "",
      last_name: user?.lastName || "",
      phoneNo: user?.phoneNo || "",
      profile_picture: user?.image || "",
      dialCode: dialCode,
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .required("Email is required!")
        .matches(
          /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i,
          "Enter a valid email address!"
        ),
      first_name: Yup.string()
        .required("First Name is required")
        .min(2, "Minimum 2 characters are required")
        .max(25, "Maximum 25 characters are allowed")
        .test(
          "is-not-email",
          "Email address is not allowed in First Name",
          function (value) {
            return !Yup.string()
              .matches(
                /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i
              )
              .isValidSync(value);
          }
        ),
      last_name: Yup.string()
        .required("Last Name is required")
        .min(2, "Minimum 2 characters are required")
        .max(25, "Maximum 25 characters are allowed")
        .test(
          "is-not-email",
          "Email address is not allowed in Last Name",
          function (value) {
            return !Yup.string()
              .matches(
                /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i
              )
              .isValidSync(value);
          }
        ),
      phoneNo: Yup.string()
        .required("Phone number is required")
        .min(3, "Phone number must be at least 3 digits")
        .max(30, "Phone number must be at least 16 digits"),
    }),
    onSubmit: async (values, { setSubmitting }) => {
      if (!formik.isValid) return;
      try {
        setSubmitting(true);

        let body: {
          email: string;
          firstName: string;
          lastName: string;
          dialCode: string;
          phoneNo: string;
          image?: string;
        } = {
          email: values.email,
          firstName: values?.first_name,
          lastName: values?.last_name,
          dialCode: values?.dialCode,
          phoneNo: values?.phoneNo,
          image: values?.profile_picture,
        };

        // if (values.profile_picture) {
        //   body.image = values.profile_picture;
        // }

        let encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
        const response = await updateprofilre(encryptedBody).unwrap();
        if (response?.statusCode === 200) {
          // dispatch(
          //   setCredentials({
          //     user:{...user,firstName:values.first_name,lastName:values.last_name,image:profile_picture},
          //     token:getFromStorage(STORAGE_KEYS.token)
          //   })
          // )
          successToast("Profile Updated Successfully.");
          const token = getFromStorage(STORAGE_KEYS.token);
          navigate("/dashboard");
        }
      } catch (error: any) {
        errorToast("error");
      } finally {
        setSubmitting(false);
      }
    },
  });

  const handleChangePhone = (phone: any, country: any) => {
    formik.setFieldValue("phoneNo", phone?.replace(country?.dialCode, ""));
    setPhoneCode(
      country?.dialCode.includes("+") ? "" : "+" + country?.dialCode
    );
  };

  useEffect(() => {
    setPhoneCode(user?.dialCode || "");
    setProfilePicture(user?.image || "");
  }, [user]);

  return (
    <>
      <MainContainer>
        <div className="main_loyout">
          <div className="dashboard">
            <h1>Edit User Profile</h1>
          </div>
          <Card className="cards">
            <form onSubmit={formik.handleSubmit}>
              <CardContent sx={{ p: 1 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography className="custom_label">Image</Typography>
                    {formik.values.profile_picture ? (
                      <div className="upload_image_preview">
                        <CardMedia
                          component="img"
                          image={formik.values.profile_picture}
                          alt="photo"
                        />
                        <CancelIcon
                          onClick={(e) => {
                            e.preventDefault();
                            setProfilePicture("");
                            formik.setFieldValue("profile_picture", "");
                          }}
                        />
                      </div>
                    ) : (
                      <Box className="upload_image">
                        <label htmlFor="icon-button-file">
                          <Input
                            sx={{ display: "none" }}
                            id="icon-button-file"
                            type="file"
                            inputProps={{
                              accept: "image/png,image/jpeg",
                            }}
                            onChange={handleImageUpload}
                          />
                          <Button component="span" className="upload_image_btn">
                            <img
                              src="/static/images/user_placeholder.png"
                              alt=""
                            />
                            <CameraAltIcon />
                          </Button>
                        </label>
                      </Box>
                    )}
                  </Grid>
                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <Typography className="custom_label">First Name</Typography>
                    <TextField
                      hiddenLabel
                      type={"text"}
                      name="first_name"
                      variant="outlined"
                      fullWidth
                      placeholder="First Name"
                      onBlur={formik.handleBlur}
                      value={formik.values.first_name}
                      className="text_field"
                      onChange={formik.handleChange}
                      helperText={
                        formik.touched.first_name && formik.errors.first_name
                          ? formik.errors.first_name.toString()
                          : ""
                      }
                    ></TextField>
                  </Grid>
                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <Typography className="custom_label">Last Name</Typography>
                    <TextField
                      hiddenLabel
                      type={"text"}
                      name="last_name"
                      variant="outlined"
                      fullWidth
                      placeholder="Last Name"
                      onBlur={formik.handleBlur}
                      value={formik.values.last_name}
                      className="text_field"
                      onChange={formik.handleChange}
                      helperText={
                        formik.touched.last_name && formik.errors.last_name
                          ? formik.errors.last_name.toString()
                          : ""
                      }
                    />
                  </Grid>
                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <Typography className="custom_label">Email</Typography>
                    <TextField
                      hiddenLabel
                      type="email"
                      name="email"
                      variant="outlined"
                      fullWidth
                      placeholder="Email"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.email}
                      className="text_field"
                      disabled
                      helperText={
                        formik.touched.email && formik.errors.email
                          ? formik.errors.email.toString()
                          : ""
                      }
                    ></TextField>
                  </Grid>
                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <Typography className="custom_label">
                      Phone Number
                    </Typography>
                    <PhoneInput
                      value={dialCode + formik.values.phoneNo}
                      country={"us"}
                      placeholder="0 (000) 000-000"
                      enableSearch={true}
                      inputStyle={{ width: "100%" }}
                      onChange={(phone, country) =>
                        handleChangePhone(phone, country)
                      }
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.phoneNo && formik.errors.phoneNo ? (
                      <h6 className="err_msg">
                        {formik.touched.phoneNo && formik.errors.phoneNo}
                      </h6>
                    ) : (
                      ""
                    )}
                  </Grid>
                </Grid>
                <div className="form_btn">
                  <Button
                    size="large"
                    type="submit"
                    className="btn btn_primary"
                    disabled={formik.isSubmitting}
                  >
                    Save
                  </Button>
                </div>
              </CardContent>
            </form>
          </Card>
        </div>
      </MainContainer>
    </>
  );
};

export default Profile;
function showToast(arg0: string) {
  throw new Error("Function not implemented.");
}
